import { styled } from '@mui/material/styles'
import React from 'react'
import { TextInput } from 'react-admin'

const PREFIX = 'VatCodeInput'

const classes = {
  dFlex: `${PREFIX}-dFlex`,
  width: `${PREFIX}-width`,
}

const StyledTextInput = styled(TextInput)({
  [`& .${classes.dFlex}`]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
  },
  [`&.${classes.width}`]: {
    width: '256px',
  },
})

const VatCodeInput: React.FC = () => {
  return (
    <StyledTextInput
      className={classes.width}
      source="vat"
      label="form.fields.vat"
    />
  )
}

export default VatCodeInput
